"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOpenQuotation = isOpenQuotation;
exports.getEditorHTML = getEditorHTML;
exports.getQuotationHTML = getQuotationHTML;

function isOpenQuotation(html) {
  return html.startsWith('<div class="webmail_original">') || !~indexOfReplyQuote(html);
}

function indexOfReplyQuote(html) {
  //hidden gmail quotation
  var matchResult = html.match(/<br><div class="(webmail_quote|gmail_quote)">/);
  return matchResult ? matchResult.index : -1;
}

function getEditorHTML(html) {
  var index = indexOfReplyQuote(html);
  return ~index ? html.slice(0, index) : html;
}

function getQuotationHTML(html) {
  var index = indexOfReplyQuote(html);
  return ~index ? html.slice(index) : '';
}
//# sourceMappingURL=utils.js.map